var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"key"},[_c('span',{staticClass:"quote"},[_vm._v("\"")]),_vm._v(_vm._s(_vm.keyName)),_c('span',{staticClass:"quote"},[_vm._v("\"")]),_vm._v(": ")])
}
var staticRenderFns = []

export { render, staticRenderFns }